//文字コードはutf-8

import { initTypingAnimation, getTypingDuration } from './typingAnimation.js';

function startBgZoom(durationMs) {
    const top = document.querySelector('.jsTop');
    if (!top) return;
    if (durationMs) {
        top.style.setProperty('--bg-zoom-duration', `${durationMs}ms`);
    }
    top.classList.add('is-bg-zoom');
}

function showImmediately(overlay) {
    overlay.classList.add('is-done');
    const typingDuration = initTypingAnimation();
    startBgZoom(typingDuration);
}

export async function initEntryAnimation() {
    const overlay = document.querySelector('.jsEntryAnimation');
    if (!overlay) return;

    const logoWrap = overlay.querySelector('.jsEntryLogo');
    if (!logoWrap) return;

    // Skip on normal refresh
    if (sessionStorage.getItem('entryAnimationPlayed')) {
        showImmediately(overlay);
        return;
    }

    // Fetch SVG and inject inline so we can manipulate fill/stroke
    const res = await fetch('/wp-content/themes/extreme/assets/img/common/img_logo.svg');
    const svgText = await res.text();
    logoWrap.innerHTML = svgText;

    const svg = logoWrap.querySelector('svg');
    svg.classList.add('topEntry__logo');

    const body = document.body;
    body.style.overflow = 'hidden';

    // Phase 1: Outline fades in (0 – 1.2s)
    overlay.classList.add('is-drawing');

    // Phase 2: Fill red (1.2 – 1.8s)
    setTimeout(() => {
        overlay.classList.remove('is-drawing');
        overlay.classList.add('is-filling');
    }, 1200);

    // Phase 3: White bg fades to bg image + logo turns white (1.8 – 2.4s)
    setTimeout(() => {
        overlay.classList.remove('is-filling');
        overlay.classList.add('is-revealing');
    }, 1800);

    // Phase 4: Strips wipe to reveal topKv, logo stays visible (2.8s)
    // Start bg zoom here — duration covers strip time (1400ms) + typing
    setTimeout(() => {
        overlay.classList.remove('is-revealing');
        overlay.classList.add('is-transitioning');
        body.style.overflow = '';

        const typingDuration = getTypingDuration();
        startBgZoom(1400 + typingDuration);
    }, 2800);

    // Phase 5: Overlay gone after strips finish (2.8 + 0.8s delay + 0.6s anim ≈ 4.2s)
    setTimeout(() => {
        overlay.classList.add('is-done');
        initTypingAnimation();

        sessionStorage.setItem('entryAnimationPlayed', 'true');
    }, 4200);
}
